import { useState } from 'react';
import {
  ChevronDownIcon,
  ChevronRightIcon,
  SparklesIcon,
  MagnifyingGlassIcon,
  PencilSquareIcon,
  BeakerIcon,
  WrenchIcon,
} from '@heroicons/react/24/outline';

interface ReasoningBlockProps {
  steps: string[];
}

function StepIcon({ text }: { text: string }) {
  const t = text.toLowerCase();

  if (t.includes('disgenet') || t.includes('buscar') || t.includes('search') || t.includes('query')) {
    return <MagnifyingGlassIcon className="reasoning-step-icon" />;
  }
  if (
    t.includes('sintetiz') ||
    t.includes('redact') ||
    t.includes('escrib') ||
    t.includes('resumir') ||
    t.includes('write') ||
    t.includes('summariz') ||
    t.includes('unified') ||
    t.includes('summary') ||
    t.includes('using the results')
  ) {
    return <PencilSquareIcon className="reasoning-step-icon" />;
  }
  if (t.includes('analiz') || t.includes('analyz') || t.includes('extract') || t.includes('process')) {
    return <BeakerIcon className="reasoning-step-icon" />;
  }

  return <WrenchIcon className="reasoning-step-icon" />;
}

export default function ReasoningBlock({ steps }: ReasoningBlockProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (!steps?.length) return null;

  return (
    <div className="reasoning-block">
      <button
        type="button"
        className="reasoning-header"
        onClick={() => setIsOpen(prev => !prev)}
        aria-expanded={isOpen}
      >
        <span className="reasoning-header-left">
          <SparklesIcon className="reasoning-icon" />
          <span>
            Reasoning steps · {steps.length} step{steps.length !== 1 ? 's' : ''}
          </span>
        </span>
        {isOpen ? (
          <ChevronDownIcon className="reasoning-icon" />
        ) : (
          <ChevronRightIcon className="reasoning-icon" />
        )}
      </button>

      {isOpen && (
        <div className="reasoning-content">
          <ol className="reasoning-steps-list">
            {steps.map((step, i) => (
              <li key={i} className="reasoning-step-item">
                <span className="reasoning-step-number">{i + 1}</span>
                <StepIcon text={step} />
                <span className="reasoning-step-text">{step}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}
